import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchTicker = async () => {
    const res = await api.get("/market/ticker");
    return res.data;
};

export const fetchBlogs = async () => {
    const res = await api.get("/blogs");
    return res.data;
};

export const fetchBlog = async (slug) => {
    const res = await api.get(`/blogs/${slug}`);
    return res.data;
};

export const submitContact = async (payload) => {
    const res = await api.post("/contact", payload);
    return res.data;
};

export const subscribeLead = async (email) => {
    const res = await api.post("/leads", { email, source: "newsletter" });
    return res.data;
};

export const LIVE_ACCOUNT_URL = "https://user.xpomarkets.co/sign-up";
export const DEMO_ACCOUNT_URL = "https://user.xpomarkets.co/sign-up";
export const LOGIN_URL = "https://user.xpomarkets.co/login";

export const MT5_WINDOWS_URL =
    "https://customer-assets.emergentagent.com/job_xpo-market-engine/artifacts/dtp9uspb_xpomarkets5setup.exe";
export const MT5_IOS_URL =
    "https://download.terminal.free/cdn/mobile/mt5/ios?server=XPOMarkets-Server";
export const MT5_ANDROID_URL =
    "https://customer-assets.emergentagent.com/job_xpo-market-engine/artifacts/dymye0m9_metatrader5.apk";

export const LOGO_WHITE =
    "https://customer-assets.emergentagent.com/job_51f38290-0410-404e-b160-085423ca1b2a/artifacts/2xgn0s30_xpo_market_white.png";
export const LOGO_DARK =
    "https://customer-assets.emergentagent.com/job_51f38290-0410-404e-b160-085423ca1b2a/artifacts/h6ysqmso_xpo_market_dark.png";
